module.exports = __webpack_public_path__ + "static/img/par8.b8576e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par8.png
// module id = 1Mad
// module chunks = 0